import Individual from "marketplace/individuals/individual";

/**
 * Somebody a forum names: a current participant, or a person who wrote in it and has since left
 * (#6878). Someone who left is named so their earlier messages keep an author, and is not a member.
 */
export default class ForumParticipant {
  public readonly individual: Individual;
  public readonly hasLeft: boolean;

  /** The name to show beside what they wrote: someone who left is marked as having left. */
  public get displayName(): string {
    return this.hasLeft ? `${this.individual.fullName} (left)` : this.individual.fullName;
  }

  public constructor(individual: Individual, hasLeft: boolean) {
    this.individual = individual;
    this.hasLeft = hasLeft;
  }
}
